import styled from 'styled-components';

export const Subheader = styled.div`
  margin: 0;

  font-size: 18px;
  line-height: 1.4;

  @media (min-width: 1200px) {
    font-size: 22px;
  }
`;

export const H2 = styled.h2`
  margin: 0;

  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;

  & + ${Subheader} {
    margin-top: 12px;

    @media (min-width: 1200px) {
      margin-top: 4px;
    }
  }

  @media (min-width: 1200px) {
    font-size: 34px;
  }
`;

export const Footnote = styled.div`
  color: #969CA3;
  font-size: 14px;
  line-height: 1.4;
`;
